export default "__VITE_ASSET__ed718ecf__"